<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1></h1>
        <span class="pull-right icon-right orange" @click="sendImgs()">提交</span>
      </div>
      <div class="liner"></div>
    </div>

     <div class="main-page">

        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix group-txt img-more" @click.prevent="isHideSelectStudent = false">
              <span class="pull-left">学生：</span><i class="red must">*</i>
              <span class="pull-right gray font-12 margin-x-15">{{studentInfo.studentName ? studentInfo.studentName : '选择学生'}}</span>
            </a>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <label class="clearfix  group-txt">
              <span class="pull-left">身高：</span><i class="red must pull-left">*</i>
              <span class="pull-right gray"><input v-model="studentHeight" class="text-right font-12 margin-x-15" type="number" placeholder="请输入" onkeyup="value=value.replace(/[^\d.]/g,'')"/><cite>cm</cite></span>
            </label>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <label class="clearfix  group-txt">
              <span class="pull-left">体重：</span><i class="red must pull-left">*</i>
              <span class="pull-right gray"><input v-model="studentWeight" class="text-right font-12 margin-x-15"  type="number" placeholder="请输入" onkeyup="value=value.replace(/[^\d.]/g,'')"/><cite>kg</cite></span>
            </label>
          </li>

          <li class="list-group">
            <div class="liner"></div>
            <a class="clearfix  group-txt img-more" @click="openPicker('picker')">
              <span class="pull-left">测量时间：</span><i class="red must pull-left">*</i>
              <span class="pull-right gray font-12 margin-x-15">{{dateString ? dateString : '请选择'}}</span>
            </a>
          </li>
        </ul>

      <div class="padding-15 bg-white">
        <textarea class="font-14" width="100%" rows="5" placeholder="写下您的评论，记录您陪伴孩子成长的每一刻" v-model="content"></textarea>
        <div class="add-pic">
          <ul class="list-group-item clearfix">
            <li v-for="(image, index) in imagesList">
              <!-- <div>
                <img :src="image.baseAcessPath + image.thumb" width="80" height="80"/><span class="del" v-tap="delImage(index)">删除</span>
              </div> -->
              <div @click="index = index, isHideImg = false, imageSrc = image.baseAcessPath + image.thumb">
                <img :src="image.baseAcessPath + image.thumb" width="80" height="80"/>
              </div>
            </li>
            <li v-if="imagesList.length < 6">
              <div class="button-add" @click="capturePhoto();" v-if="isAndroid"></div>
              <div class="button-add" v-else>
                <form enctype="multipart/form-data" method="post" name="fileinfo">
                  <input type="file" name="pic" id="pic" accept="image/*" multiple="multiple" @change="updateImage()"/>
                </form>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 选择学生 -->
    <dialogStudents :isHideSelectStudent="isHideSelectStudent" :studentFirstCharList="studentFirstCharList" v-on:close="closeDialogStudents" v-on:selected="selectedStudent"></dialogStudents>

    <div class="main-page" v-if="!isHideImg">
      <div class="topbar">
        <div class="clearfix main-wrap">
          <a class="pull-left img-back" @click.prevent="isHideImg = true">返回</a>
          <h1></h1>
          <span class="pull-right icon-right orange" @click="isHideDelImage = false">删除</span>
        </div>
        <div class="liner"></div>
      </div>

      <div class="bg-white" @click="isHideImg = true">
        <img class="mid-align" :src="imageSrc" width="100%" />
      </div>
    </div>
    <!-- 删除图片 -->
    <div class="maskdiv" v-if="!isHideDelImage">
      <div class="bottom-block text-center" style="background:none">
        <ul class="list-group-item  tinny">
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click.prevent="delImage()"><span class="orange block font-16">删除</span></a>
          </li>
        </ul>
        <ul class="list-group-item tinny" style="margin:0">
          <li class="list-group">
            <div class="liner"></div>
            <a class="group-txt" @click.prevent="isHideDelImage = true"><span class="block font-16">取消</span></a>
          </li>
        </ul>
      </div>
    </div>

    <mt-datetime-picker ref="picker" v-model="value" type="date" year-format="{value} 年"
      month-format="{value} 月" date-format="{value} 日"  @confirm="handleChange">
    </mt-datetime-picker>
</div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { service, uploadMulUrl } from '../../service'
import { mapGetters, mapMutations } from 'vuex'
// component
import dialogStudents from '../../components/student/dialogStudents'

export default {
  computed: mapGetters({
    studentFirstCharList: 'getStudentsByFirstChar'
  }),
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      login_data: JSON.parse(window.localStorage['login_data']),
      curcheId: 0,
      teacherId: 0,
      content: '',
      subject: '',
      studentHeight: '',
      studentWeight: '',
      birthdayDay: '',
      birthdayMonth: '',
      birthdayYear: '',
      score: '',
      imagesList: [],
      // studentList: [],
      subjectList: [],
      isHideSelectStudent: true,
      studentInfo: {},
      save_Growth_Index_para: service.setPara('saveGrowthIndex'),
      get_new_student_list_para: service.setPara('getNewStudentList'),
      isPublishing: false,
      isHideImg: true,
      isHideDelImage: true,
      index: 0,
      imageSrc: '',
      fileList: [],
      pickerVisible: false,
      value: new Date(),
      dateString: '',
      dateStringToNet: '',
      pickerStartDate: '',
      pickerEndDate: '',
      isAndroid: true
    }
  },
  components: {
    dialogStudents
  },
  mounted: function () {
    let b = window.browser()
    this.isAndroid = b.android

    this.pickerStartDate = new Date().format('yyyy年MM月dd日')
    // this.pickerStartDate.getFullYear - 3
    this.curcheId = this.cookie_login_data.curcheId
    this.teacherId = this.cookie_login_data.teacherId
    this.get_new_student_list_para.curcheId = this.curcheId
    this.get_new_student_list_para.sfzt = '在托'
    this.getStuList()
  },
  methods: {
    ...mapMutations([
      'receiveStudents'
    ]),
    openPicker (picker) {
      this.$refs[picker].open()
    },
    getStuList: function () {
      // let that = this
      // let obj = {context: this, para: this.get_new_student_list_para, successFun: (response) => {
      //   that.studentList = response.data
      // }}
      // service.request(obj)
      // this.receiveStudents(this.get_new_student_list_para)
      this.$store.dispatch('receiveStudents', this.get_new_student_list_para)
    },
    insertHeightAndWeight: function () {
      if (!this.studentInfo.studentName) {
        Toast('请选择学生')
        return
      }

      // if ($.trim(this.subject) == '') {
      //   Toast('请选择科目')
      //   return
      // }

      if ($.trim(this.studentHeight) == '') {
        Toast('请填写学生身高')
        return
      }

      if ($.trim(this.studentWeight) == '') {
        Toast('请填写学生体重')
        return
      }

      // if (this.isPublishing) {
      //   return
      // } else {
      //   this.isPublishing = true
      // }
      // if (this.birthdayYear && this.birthdayMonth && this.birthdayDay) {
      //   var tempDate = new Date()
      //   try {
      //     tempDate.setDate(this.birthdayDay)
      //     tempDate.setMonth(this.birthdayMonth - 1)
      //     tempDate.setFullYear(this.birthdayYear)
      //     this.birthday = tempDate.format('yyyyMMdd')
      //   } catch (e) {
      //     this.birthday = ''
      //   }
      // }

      this.save_Growth_Index_para.teacherId = this.teacherId
      this.save_Growth_Index_para.curcheId = this.curcheId
      this.save_Growth_Index_para.field3 = $.trim(this.content)
      this.save_Growth_Index_para.studentId = this.studentInfo.studentId
      this.save_Growth_Index_para.imageList = this.imagesList
      this.save_Growth_Index_para.wight = $.trim(this.studentWeight)
      this.save_Growth_Index_para.height = $.trim(this.studentHeight)
      this.save_Growth_Index_para.growthDate = this.dateStringToNet
      Indicator.open('发布中...')

      // let that = this
      let obj = {context: this, para: this.save_Growth_Index_para, successFun: (response) => {
        // that.save_Growth_Index_para.scoreId = response.data
        // that.saveImgTolocalStorage(that.save_Growth_Index_para)
        window.history.go(-1)
      }}
      service.request(obj)
    },
    handleChange: function (value) {
      this.dateString = value.format('yyyy年MM月dd日')
      this.dateStringToNet = value.format('yyyy年MM月dd日')
    },
    updateImage: function () {
      let nl = 0
      let files = document.getElementById('pic').files
      if (files.length === 0) {
        return
      }

      if (files.length + this.imagesList.length > 6) {
        Toast('最多只能再上传' + (6 - this.imagesList.length) + '张图片')
        return
      }
      for (let i = 0; i < files.length; i++) {
        Indicator.open()
        lrz(files[i], {width: 1024})
        .then((rst) => {
          nl++
          let imageInfo = {}
          imageInfo.baseAcessPath = rst.base64
          imageInfo.image = ''
          imageInfo.thumb = ''
          imageInfo.fileName = rst.origin.name
          this.imagesList.push(imageInfo)
          let f = {}
          f.file = rst.file
          f.name = rst.origin.name
          this.fileList.push(f)
          if (nl == files.length) {
            Indicator.close()
          }
        })
      }
    },
    delImage: function (index) {
      // this.imagesList.splice(index, 1)
      this.imagesList.splice(this.index, 1)
      this.fileList.splice(this.index, 1)
      this.isHideDelImage = true
      this.isHideImg = true
    },
    sendImgs: function () {
      let data = new window.FormData()

      for (let i = 0; i < this.fileList.length; i++) {
        data.append('pic', this.fileList[i].file, this.fileList[i].name)
      }
      let url = uploadMulUrl + this.cookie_login_data.phoneNum + '&needThumb=1'

      let that = this
      let obj = {context: this, para: data, url: url, successFun: (response) => {
        that.imagesList = []
        for (var i = 0; i < response.data.length; i++) {
          var imageInfo = {}
          imageInfo.baseAcessPath = response.data[i].image.baseAcessPath
          imageInfo.image = response.data[i].image.srcFilePath
          imageInfo.thumb = response.data[i].image.thumbFilePath
          that.imagesList.push(imageInfo)
        }
        console.log('图片处理完成')
        that.insertHeightAndWeight()
      }}
      service.request(obj)
    },
    saveImgTolocalStorage: function (para) { // 保存图片信息到本地，便于快速读取
      var item = {}
      item.content = para.content
      item.publishDate = new Date().getTime()
      item.teacherId = para.teacherId
      item.teacherName = this.login_data[this.cookie_login_data.index].teacherName
      item.teacher_icon = this.login_data[this.cookie_login_data.index].teacherIcon

      item.studentId = para.studentId
      // item.studentName = para.studentName
      item.studentName = this.studentInfo.studentName
      item.testName = para.testName

      item.score = para.score
      item.subject = para.subject
      item.scoreId = para.scoreId

      item.isUploadOver = false
      item.baseAcessPath = this.cookie_login_data.baseAcessPath
      item.field2 = this.studentInfo.imageAddress
      var imgs = []
      for (var i = 0; i < this.imagesList.length; i++) {
        var img = {}
        img.baseAcessPath = this.imagesList[i].baseAcessPath
        img.imageAddress = this.imagesList[i].image
        img.thumbAddress = this.imagesList[i].thumb
        imgs.push(img)
      }
      item.picList = imgs
      window.localStorage['score_new'] = JSON.stringify(item)
    },
    capturePhoto: function () {
      Indicator.open()
      navigator.camera.getPicture(this.onPhotoDataSuccess, this.onFail, { quality: 50, destinationType: navigator.camera.DestinationType.DATA_URL, sourceType: navigator.camera.PictureSourceType.PHOTOLIBRARY, targetWidth: 1000, targetHeight: 2000 })
    },
    onPhotoDataSuccess: function (imageData) {
      let imageInfo = {}
      imageInfo.baseAcessPath = 'data:image/jpeg;base64,' + imageData
      imageInfo.image = ''
      imageInfo.thumb = ''
      this.imagesList.push(imageInfo)
      let f = {}
      f.file = this.dataURLtoBlob(imageInfo.baseAcessPath)
      f.name = this.fileList.length + '.png'
      this.fileList.push(f)
      Indicator.close()
    },
    onFail: function (message) {
      Indicator.close()
      // alert('Failed because: ' + message)
    },
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = window.atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new window.Blob([u8arr], {type: mime})
    },
    closeDialogStudents () { // 关闭选择学生弹出框
      this.isHideSelectStudent = true
    },
    selectedStudent (student) {
      this.studentInfo = student
      this.isHideSelectStudent = true
    }
  }
}
</script>
<style scoped>
  .list-group-item.primary{padding-right:32px;}
</style>



// WEBPACK FOOTER //
// HeightAndWeightPublish.vue?027784e0